import { createContext } from "react"

export const ProjectBookerContext = createContext()
